import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledInfoContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 40px;
	padding: 5px 10px;
	background-color: rgba(0, 0, 0, 0.5);
	border-radius: 10px;
	transition: background-color 0.3s ease;

	& > ${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledCount = styled.div<{ $color?: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 20px;
	height: 20px;
	padding: 0 5px;
	border-radius: 5px;
	background-color: ${({ $color }) => $color ?? '#1782ff'};

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}
`;

export { StyledContainer, StyledCount, StyledInfoContainer };
